<template>
    <el-container>
        <el-header height="70px">
            <main-header />
        </el-header>
        <el-container>
            <el-aside class="no-print" width="248px">
                <navigation />
            </el-aside>
            <el-main type="flex">
                <slot>
                </slot>
            </el-main>
        </el-container>
        <el-footer height="20px">
            <main-footer />
        </el-footer>
    </el-container>
</template>

<script>
import Navigation from './Navigation';
import Header from './Header';
import Footer from './Footer';
import { eventBus } from '@/common/eventBus';
import '@/assets/styles/main.scss';

export default {
    data: function() {
        return {};
    },
    components: {
        'navigation': Navigation,
        'main-header': Header,
        'main-footer': Footer
    },
    beforeMount() {
        eventBus.$on('catch-response-error', payload => {
            const errorResponse = payload.errorResponse;
            if (errorResponse &&
                this.$store.getters.isAuthenticated &&
                //отключение сообщения при отсутствии сохранненых настроек у пользователя
                errorResponse.config.url !== '/api/preferences/'
            ) {
                let message = `<div class="alert-title">При обращении к адресу ${errorResponse.config.url.slice(0, 50)} <br> произошла ошибка: <br></div>`;
                if (errorResponse.status === 422) {
                    const errorsList = Object.keys(errorResponse.data.errors).map(item => errorResponse.data.errors[item][0]);
                    message += '<div class="alert-body">неправильно заполнены поля: <br>• ' + errorsList.join(' <br>• ') + '</div>';
                } else {
                    message += errorResponse.data.error;
                }
                this.$message({
                    showClose: true,
                    dangerouslyUseHTMLString: true,
                    message: message,
                    type: 'error',
                    duration: 5000,
                    customClass: this.alertClass()
                });
            }
        });
        this.checkAuth();
    },
    methods: {
        async getAllUsefulData() {
            await this.$store.dispatch('references/loadReferences');
        },
        async checkAuth() {
            if (this.$store.getters.isAuthenticated) {
                await this.$store.dispatch('getAuth').then(
                    () => {
                        this.getAllUsefulData();
                    },
                    error => {
                        console.log(error);
                        this.$store.commit('clearToken');
                    }
                );
            }
        }
    }
};
</script>
